import { useEffect, useState } from "react";

let lastMinerId: number | undefined;
const listeners = new Set<() => void>();

export const lastMinerActivity = {
  set(id: number) {
    if (lastMinerId === id) return;
    lastMinerId = id;
    listeners.forEach((listener) => listener());
  },

  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },

  getSnapshot() {
    return lastMinerId;
  },
};

export function useIsLastMinerActivity(id: number): boolean {
  const [currentId, setCurrentId] = useState(lastMinerActivity.getSnapshot());

  useEffect(
    () => lastMinerActivity.subscribe(
      () => setCurrentId(lastMinerActivity.getSnapshot())
    ),
    []
  );

  return currentId === id;
}
